import { UserMergeRequestListItem } from '../../types';
import { ActionsColumn } from '@otp/ui';
import { Edit, MinusOutlined, Tick } from '@otp/icons';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'src/components/common/router/constants';
import { useState } from 'react';
import {
  ActionForm,
  ActionFormType,
} from 'src/components/user-merge-requests/item/form/action-form';
import {
  UserMergeRequestsDocument,
  UserMergeRequestStatus,
} from 'src/graphql/generated/graphql';

type ActionsFieldProps = {
  entity: UserMergeRequestListItem;
};

export const AdminActionsField = ({ entity }: ActionsFieldProps) => {
  const [openActionFormType, setOpenActionFormType] =
    useState<ActionFormType | null>(null);

  const navigate = useNavigate();

  const onEdit = () => {
    navigate(`${Routes.userMergeRequests.path}/${entity.id}`);
  };

  const onApprove = () => {
    setOpenActionFormType(ActionFormType.APPROVE);
  };

  const onReject = () => {
    setOpenActionFormType(ActionFormType.REJECT);
  };

  const icons =
    entity.status === UserMergeRequestStatus.Pending
      ? [
          {
            icon: <Edit />,
            onClick: onEdit,
          },
          {
            icon: <Tick />,
            onClick: onApprove,
          },
          {
            icon: <MinusOutlined />,
            onClick: onReject,
          },
        ]
      : [];

  return (
    <>
      <ActionsColumn icons={icons} />
      {openActionFormType && (
        <ActionForm
          type={openActionFormType}
          entity={entity}
          refetchQueries={[UserMergeRequestsDocument]}
          onCancel={() => setOpenActionFormType(null)}
          onSave={() => setOpenActionFormType(null)}
        />
      )}
    </>
  );
};
